import React, { useState, useEffect, Fragment } from 'react';
import {
  Card,
  CardBody,
  Button,
  ButtonGroup,
  Form,
  CustomInput,
  FormGroup,
  Input,
  Label,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Tooltip,
  Row,
  CardImg,
} from 'reactstrap';
import ImageGallery from '../../../propinfo/gallery/index';
import {
  Colxx,
  Separator,
} from '../../../../../../components/common/CustomBootstrap';
import Switch from 'rc-switch';
import 'rc-switch/assets/index.css';
import DynamicFlow from './DynamicFlow';
import { AxiosAPI, getGroupID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_QuestionSets } from '../../../../../../constants/APIs';
import { NotificationManager } from '../../../../../../components/common/react-notifications';
let arr = [];
export default function Features({
  channelDetails,
  saveIntegration,
}) {
  const [showRooms, setShowRooms] = useState(channelDetails?.showRoomsButton || false);
  const [showRates, setShowRates] = useState(channelDetails?.showRatesButton || false);
  const handleShowRooms = (e) => {
    console.log('e', e, e?.target);
    setShowRooms(e);
  };

  const handleShowRates = (e) => {
    console.log('e', e, e?.target);
    setShowRates(e);
  };

  const handleSave = () => {
    let settings = channelDetails;
    settings.showRoomsButton = showRooms;
    settings.showRatesButton = showRates;
    console.log('auto', settings);
    saveIntegration({ settings });
  };

  return (
    <Fragment>
      <Card className="mb-4">
        <CardBody>
          <div className="text-center mb-2">
            <h6>Features</h6>
          </div>
          <Separator className="mb-3" />
          <div className="row mt-2 ml-2 mb-3">
            <Colxx md="12" className="mb-2 d-flex">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small "
                checked={showRooms}
                name="showRooms"
                onChange={(e) => handleShowRooms(e)}
              />
              <h6 className="ml-2"> Show Rooms Button</h6>
            </Colxx>
            <Colxx md="12" className="mb-2 d-flex">
              <Switch
                className="agentswitch custom-switch-primary custom-switch-small "
                checked={showRates}
                name="showRates"
                onChange={(e) => handleShowRates(e)}
              />
              <h6 className="ml-2"> Show Rates Button</h6>
            </Colxx>
            {/* <Separator className="mb-3" /> */}
          </div>
          <Separator className="mb-3" />
          <Colxx md="12" className="text-center">
            <Button onClick={() => handleSave()} color="primary" size="xs">
              Save
            </Button>
          </Colxx>
        </CardBody>
      </Card>
    </Fragment>
  );
}
